<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <div v-if="showCp" class="py-1 position-absolute"  style="z-index:2; background: #ffbd002b;">
    <strong>Current route path:</strong> {{ $route.fullPath }}
  </div>
  <!-- <HeaderTop/> -->
  <component :is="layout">
    <div role="main" class="main">
      
      <router-view :contract="contract"></router-view>
    </div>
  </component>
  <!-- <HomeView msg="Welcome to Your Vue.js App" /> -->
  <!-- <footerBottom/> -->
</template>

<script>
// import HomeView from './components/HomeView.vue'
// import HeaderTop from './components/Header.vue'
// import footerBottom from './components/footer.vue'
// import MainBody from './components/main.vue'

import DefaultLayout from './layouts/DefaultLayout.vue'
import HomeLayout from './layouts/HomeLayout.vue'
// // import axios from 'axios';
// const sgid = 'BAh7CEkiCGdpZAY6BkVUSSIbZ2lkOi8vZXUtc2lnbi9TaWduZXIvMgY7AFRJIgxwdXJwb3NlBjsAVDoJc2lnbkkiD2V4cGlyZXNfYXQGOwBUSSIdMjAyNC0wNS0xMFQxMDoxNDozNC41MDRaBjsAVA==--31148963789311b0b48662d2b171d71401fc4966'
// const uuid = 'df3f96cd-0a87-4812-9ef5-8c2ce03758d4'
// const baseUrl = 'https://ngrok.dnose.tw'
// const getContractUrl = `${baseUrl}/api/v1/signing_digital_contract/${uuid}/${sgid}.json`
var currentURL = (document.URL);
const sgid = currentURL.split('://')[1].split('/')[3];
const uuid = currentURL.split('://')[1].split('/')[2];
// const baseUrl = 'https://ngrok.dnose.tw'
// const getContractUrl = `${baseUrl}/api/v1/signing_digital_contract/${uuid}/${sgid}.json`

export default {
  name: 'App',
  data() {
    return {
      showCp: true,
      sgid:sgid,
      uuid:uuid,
    }
  },
  props: {
    contract: {
      type: Object
    },
  },
  beforeMount(){

  },
  mounted () {
    this.changeShow()
  },
  methods: {
        changeShow(){
            if (process.env.NODE_ENV == 'development') {
                this.showCp = true
            } else {
                this.showCp = false
            }
        }
  },
  components: {
    DefaultLayout,
    HomeLayout
    // HomeView,
    // HeaderTop,
    // footerBottom,
    // MainBody
  },
  computed: {
    layout () {
      console.log(this.$route.meta.layout)
      return (this.$route.meta.layout || DefaultLayout)
    }
  },
}

</script>

<style lang="scss" scoped>
#app {
  font-family: "Noto Sans TC", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
body{
  font-family: "Noto Sans TC", serif !important;
  background-color: #f7f7f7 !important;
}
.content{
  padding: 0 10px;
}
</style>
